// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2TF5B","footer":"ModalInfo_footer__ci_Qd"};